import { atom } from 'recoil'

export const isLoadingTestMailState = atom({
  key: 'isLoadingTestMailState',
  default: false
})
